export default "__VITE_ASSET__CFAYF9Iq__"